<template>
  <div id="repository-prompting" class="flex">
    <div
      id="repository-prompting-tabs"
      class="sticky left-0 z-40 flex-shrink-0 overflow-y-auto border-r top-18 w-60 bg-pure-white border-slate-400"
      :style="{ height: 'calc(100vh - 4.5rem)' }"
    >
      <div
        class="sticky top-0 z-10 flex items-center px-6 py-6 border-b bg-pure-white border-slate-400"
      >
        <BlTextTitle3 text="Prompting" />
      </div>
      <div class="flex flex-col gap-1 px-3 py-1">
        <div v-for="(tab, idx) in tabs" :key="idx">
          <div v-if="tab.divider" class="h-0.5 w-full bg-slate-300"></div>
          <router-link
            v-else
            :to="tab.target"
            class="relative flex items-center h-12 gap-2 px-3 transition-all duration-300 rounded"
            :class="[tab.isActive ? 'bg-slate-300' : 'hover:bg-hover-state']"
          >
            <BlTextSubtitle3
              :text="tab.label"
              :title="tab.label"
              class="truncate"
            />
          </router-link>
        </div>
      </div>
    </div>

    <div id="repository-prompting-body" class="flex flex-col flex-grow">
      <PromptClassic v-if="!searchParams['tab']" />
      <PromptCustom v-if="searchParams['tab'] === 'custom'" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import PromptClassic from "./prompting/Classic.vue";
import PromptCustom from "./prompting/Custom.vue";

import BlTextTitle3 from "../BlTextTitle3.vue";
import BlTextSubtitle3 from "../BlTextSubtitle3.vue";

export default {
  name: "RepositoryPrompting",
  components: {
    PromptClassic,
    PromptCustom,
    //
    BlTextTitle3,
    BlTextSubtitle3
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["currentUser"]),
    searchParams() {
      return this.$route.query || {};
    },
    tabs() {
      return [
        {
          target: "/repository/prompting",
          isActive: !this.searchParams["tab"],
          label: "Classic: Frequency-Based Prompting"
        },
        {
          target: "/repository/prompting?tab=custom",
          isActive: this.searchParams["tab"] === "custom",
          label: "Custom: Score-Based Prompting"
        }
      ];
    }
  },
  async mounted() {},
  methods: {
    ...mapActions([])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/repository/Prompting.vue